import React from 'react'

const Confirm = () => {
  return (
    <div>
      <h1>You are confirm as a member</h1>
    </div>
  )
}

export default Confirm;